import { combineReducers } from "@reduxjs/toolkit";
import sampleReducer from "../slices/sample";
import jobReducer from "../slices/job";
import categoryReducer from "../slices/category";
import problemCodeReducer from "../slices/problemCode";
import siteReducer from "../slices/site";
import jobTypeReducer from "../slices/jobType";
import userReducer from "../slices/user";
import siteManagerReducer from "../slices/siteManager";
import toastReducer from "../slices/toast";
import siteTypeReducer from "../slices/siteType";
import optionsReducer from "../slices/options";
import attachmentReducer from "../slices/attachment";
import reportReducer from "../slices/report";
import pickerReducer from "../slices/picker";
import jobSourceReducer from "../slices/jobSource";
import jobStatusReducer from "../slices/jobStatus";
import communicationMethodReducer from "../slices/communicationMethod";
import authenticationReducer from "../slices/authentication";
import equipmentReducer from "../slices/equipment";
import filterSetReducer from "../slices/filterSet";
import sharedReducer from "../slices/shared";
import milestoneReducer from "../slices/milestones";
import attachmentTypeReducer from "../slices/attachmentType";
import highlightReducer from "../slices/calendarHighlight";

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  attachments: attachmentReducer,
  attachmentType: attachmentTypeReducer,
  category: categoryReducer,
  communication: communicationMethodReducer,
  equipment: equipmentReducer,
  filterSets: filterSetReducer,
  highlight: highlightReducer,
  job: jobReducer,
  jobSource: jobSourceReducer,
  jobStatus: jobStatusReducer,
  jobType: jobTypeReducer,
  milestone: milestoneReducer,
  options: optionsReducer,
  picker: pickerReducer,
  problemCode: problemCodeReducer,
  report: reportReducer,
  sample: sampleReducer,
  shared: sharedReducer,
  site: siteReducer,
  siteManager: siteManagerReducer,
  siteType: siteTypeReducer,
  toast: toastReducer,
  user: userReducer,
});

export default rootReducer;
